<template>
  <router-link
    v-if="!item.children"
    :to="item.path ? item.path : ''"
    class="text-decoration-none text-surface"
  >
    <v-list-item
      :prepend-icon="item.icon"
      :title="item.title"
      :active="route.path === item.path"
      color="primary"
    />
  </router-link>

  <v-list-group v-else>
    <template #activator="{ props }">
      <v-list-item
        v-tooltip="item.title"
        v-bind="props"
        :prepend-icon="item.icon"
        :title="item.title"
        :active="item.children.some(c => c.path === route.path)"
        color="primary"
      />
    </template>

    <div
      v-for="(child, j) in item.children"
      :key="j"
    >
      <drawer-item v-if="child.children?.length" :item="child" />
      <router-link
        v-else
        :to="child.path ? child.path : ''"
        class="text-decoration-none text-surface"
      >
        <v-list-item
          :title="child.title"
          :active="route.path === child.path"
          color="primary"
        />
      </router-link>
    </div>
  </v-list-group>
</template>
<script lang="ts" setup>
import DrawerItemType from '@/types/DrawerItem'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const { item } = defineProps<{ item: DrawerItemType }>()

const route = computed(() => router.currentRoute.value)

</script>
<style lang="scss" scoped>
.v-list-group__items .v-list-item {
  padding-inline-start: calc(16px + var(--indent-padding) / 2) !important;
}
</style>
